<template>
  <div class="c-requestAddContents">
    <h2
      class="c-requestAddContents_heading c-requestAddContents_heading-noBorder"
      id="requestAddContentsCategory"
    >
      依頼したいカテゴリを選びましょう
      <span class="c-requestAddContents_label c-requestAddContents_label-required">必須</span>
    </h2>
    <contents-category @change="changeCategory" />

    <div
      class="c-requestAddContents_body"
      v-if="isValidCategory"
    >
      <hr
        class="c-requestAddContents_divider"
        v-if="isPC"
      >
      <h2
        class="c-requestAddContents_heading"
        id="requestAddContentsDetail"
      >
        依頼の内容を入力しましょう
      </h2>
      <div
        class="c-requestAddContents_detailItem"
        :class="{
          'c-requestAddContents_detailItem-noTitle': requestItem.title === '',
          'c-requestAddContents_detailItem-noTitleAndSubTitle': requestItem.title === '' && requestItem.subTitle === ''
        }"
        v-for="requestItem in requestItemsList"
        :key="requestItem.id"
      >
        <h3
          class="c-requestAddContents_title"
          v-if="requestItem.title"
        >
          {{ requestItem.title }}
          <span
            class="c-requestAddContents_label c-requestAddContents_label-required"
            v-if="requestItem.requiredFlag"
          >必須</span>
          <span
            class="c-requestAddContents_label"
            v-else
          >任意</span>
        </h3>
        <h4
          class="c-requestAddContents_subTitle"
          v-if="requestItem.subTitle"
        >
          {{ requestItem.subTitle }}
        </h4>
        <ul
          v-if="cautionText(requestItem.optionJson.caution).length > 0"
          class="c-requestAddContents_caution"
        >
          <li
            v-for="(text, index) in cautionText(requestItem.optionJson.caution)"
            :key="index"
          >
            {{ text }}
          </li>
        </ul>
        <!-- eslint-disable-next-line vue/require-component-is -->
        <component
          :is="detailComponentName(requestItem.displayStyle)"
          :request-item="requestItem"
          :description-text="detailDescription"
          @change="changeDetail"
          @change-other="changeDetailOther"
          @toggle-other="toggleDetailOther"
        />
      </div>

      <hr
        class="c-requestAddContents_divider"
        v-if="isPC"
      >
      <h2
        class="c-requestAddContents_heading"
        id="requestAddContentsPrice"
      >
        予算を決めましょう
      </h2>
      <div class="c-requestAddContents_price">
        <h3 class="c-requestAddContents_title c-requestAddContents_priceTitle">
          予算
          <span class="c-requestAddContents_label c-requestAddContents_label-required">必須</span>
        </h3>
        <c-select
          name="price"
          placeholder="予算を選択してください"
          v-model="selectedPrice"
          @change.native="changePrice"
        >
          <option
            v-for="priceItem in priceItems"
            :key="priceItem.value"
            :value="priceItem.value"
          >{{ priceItem.label }}</option>
        </c-select>
        <div
          v-if="selectedCategory"
          class="c-requestAddContents_priceCaution"
          :class="{ 'c-requestAddContents_priceCaution-beforeHoldingTax': isShowWithholding }"
        >
          ※選択カテゴリの最低依頼価格は{{ $util.prettyNumberForRequest(requestLowestPrice) }}円です
        </div>
        <div v-if="isShowWithholding">
          <h4
            class="c-requestAddContents_subTitle c-requestAddContents_priceSubTitle"
            v-if="isPC"
          >
            源泉徴収税
          </h4>
          <c-checkbox
            size="is-small"
            name="withholdingTaxFlag"
            value="1"
            v-model="inputValues.withholdingTaxFlag"
          >
            源泉徴収をして支払う
          </c-checkbox>
          <p class="c-requestAddContents_priceNotice">
            ※ 源泉徴収税は購入者より税務署へ納税の手続きを行っていただくことになります。<br>
            ※ 総契約額から源泉徴収をした金額で決済できます。
          </p>
          <p class="c-requestAddContents_priceNotice">
            詳しくは<a
              :href="$coconala.helpURL('/articles/900000102386')"
              target="_blank"
            >こちら</a>
          </p>
        </div>
      </div>
      <hr
        class="c-requestAddContents_divider"
        v-if="isPC"
      >
      <h2
        class="c-requestAddContents_heading"
        id="requestAddContentsDate"
      >
        期限を決めましょう
      </h2>
      <div class="c-requestAddContents_date">
        <h3 class="c-requestAddContents_title c-requestAddContents_expireDateTitle">
          応募期限
          <span class="c-requestAddContents_label c-requestAddContents_label-required">必須</span>
        </h3>
        <c-select
          name="expireDate"
          placeholder="応募期限を選択してください"
          v-model="inputValues.expireDate"
          @change.native="changeExpireDate"
        >
          <option
            v-for="expireDateItem in expireDateItems"
            :key="expireDateItem.value"
            :value="expireDateItem.value"
          >{{ expireDateItem.label }}</option>
        </c-select>
        <p class="c-requestAddContents_expireDateNotice">
          ※購入期限は応募期限終了後1週間です。
        </p>
        <h3 class="c-requestAddContents_title c-requestAddContents_deliveryDateTitle">
          納品希望日
          <span class="c-requestAddContents_label">任意</span>
        </h3>
        <div class="c-requestAddContents_deliveryDate">
          <c-select
            name="deliveryDateYear"
            placeholder="選択"
            v-model="inputValues.deliveryDateYear"
            @change.native="changeDeliveryDate"
          >
            <option value="0"></option>
            <option
              v-for="n in 2"
              :key="n"
              :value="currentYear + n - 1"
            >{{ currentYear + n - 1 }}</option>
          </c-select>
          <span>年</span>
          <c-select
            name="deliveryDateMonth"
            placeholder="選択"
            v-model="inputValues.deliveryDateMonth"
            @change.native="changeDeliveryDate"
          >
            <option value="0"></option>
            <option
              v-for="n in deliveryMonthList"
              :key="n"
              :value="n"
            >{{ n }}</option>
          </c-select>
          <span>月</span>
          <c-select
            name="deliveryDateDay"
            placeholder="選択"
            v-model="deliveryDateDay"
            @change.native="changeDeliveryDateDay"
          >
            <option value="0"></option>
            <option
              v-for="n in deliveryDayList"
              :key="n"
              :value="n"
            >{{ n }}</option>
          </c-select>
          <span>日</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { range, findKey } from 'lodash-es'

import ContentsCategory from './components/ContentsCategory'

import ContentsCheckbox from './components/ContentsCheckbox'
import ContentsFile from './components/ContentsFile'
import ContentsNumber from './components/ContentsNumber'
import ContentsRadio from './components/ContentsRadio'
import ContentsRange from './components/ContentsRange'
import ContentsSelect from './components/ContentsSelect'
import ContentsText from './components/ContentsText'
import ContentsTextarea from './components/ContentsTextarea'
import CategoryLowestPriceMixin from './mixins/CategoryLowestPriceMixin'

const MIN_PRICE = 500 // 歴史的な理由により、予算の「〇〇円未満」はprice_min=nullではなく500で登録する
const DATE_TERM = 14 // 応募期限の選択肢に何日後まで表示するか

// テンプレートに直書きしている固定項目のname一覧
const FIXED_INPUT_NAMES = [
  'masterCategoryId',
  'priceMin', // 「予算」の選択内容から取り出す最低価格
  'priceMax', // 「予算」の選択内容から取り出す最高価格
  'withholdingTaxFlag',
  'expireDate',
  'deliveryDateYear',
  'deliveryDateMonth',
  'deliveryDateDay'
]

// 固定項目のうち、必須項目のname一覧
const FIXED_REQUIRED_INPUT_NAMES = ['masterCategoryId', 'priceMin', 'expireDate']

export default {
  name: 'RequestAddContents',
  components: {
    ContentsCategory,
    ContentsCheckbox,
    ContentsFile,
    ContentsNumber,
    ContentsRadio,
    ContentsRange,
    ContentsSelect,
    ContentsText,
    ContentsTextarea
  },
  mixins: [CategoryLowestPriceMixin],
  data() {
    return {
      inputValues: {}, // 入力値を保存する場所
      detailInputValidations: {}, // 「依頼の内容」のバリデーション結果を保存する場所
      requiredInputNames: [], // 必須項目のname一覧
      requiredDetailInputNames: [], // 必須項目のうち、「依頼の内容」に属する項目のname一覧
      remainingCount: 0, // 未入力の必須項目数
      remainingDetailCount: 0, // 未入力の必須項目のうち、「依頼の内容」に属する必須項目数
      isValidCategory: false, // カテゴリが正しく選択されているか
      selectedPrice: null, // 選択した「予算」のvalue
      deliveryMonthList: [], // 納品希望日の「月」に表示する月の一覧
      deliveryDayList: [], // 納品希望日の「日」に表示する日の一覧
      deliveryDateDay: null, // 納品希望日の「日」
      detailDescription: '' // 複数フォームの入力値に連動して出す説明文 1カテゴリに複数出す場合はオブジェクトにするなどの拡張が必要
    }
  },
  watch: {
    requestItemsList: {
      handler() {
        this.initializeData()
      },
      deep: true
    },
    remainingCount() {
      this.$emit('change-remaining-count', this.remainingCount)
    },
    inputValues: {
      handler() {
        this.$emit('change-input-values', this.inputValues)
      },
      deep: true
    }
  },
  created() {
    this.initializeData()
    this.setDeliveryDateList()
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    ...mapGetters('auth/user', ['isInvoiceAvailable']),
    ...mapGetters('master', ['flattenMasterCategories']),
    ...mapState('master', [
      'requestItemsList',
      'requestPrices',
      'requestLowestPrice',
      'requestHighestPrice'
    ]),
    priceItems() {
      let priceItemIndex = 0
      const priceItems = [
        {
          value: priceItemIndex,
          label: '見積り希望（要相談）',
          minPrice: 0,
          maxPrice: 0
        }
      ]

      this.requestPrices.forEach(price => {
        const label = this.$util.prettyNumberForRequest(price) + '円'
        priceItemIndex++
        priceItems.push({
          value: priceItemIndex,
          label,
          minPrice: price,
          maxPrice: price
        })
      })

      // カテゴリの最低価格以上の選択肢に絞る
      const lowerLimitPrice = Math.max(this.requestLowestPrice || 0, MIN_PRICE)
      return priceItems.filter(priceItem => {
        if (priceItem.minPrice === 0 && priceItem.maxPrice === 0) {
          // 見積り希望は常に残す
          return true
        }
        return (
          priceItem.maxPrice >= lowerLimitPrice && priceItem.maxPrice <= this.requestHighestPrice
        )
      })
    },
    expireDateItems() {
      const expireDateItems = []
      let dayjs = null
      for (let n = 1; n <= DATE_TERM; n++) {
        dayjs = this.$util.dayjs().add(n, 'days')
        expireDateItems.push({
          value: dayjs.format('YYYY-MM-DD'),
          label: n + '日後(' + dayjs.format('YYYY年MM月DD日中') + ')'
        })
      }
      return expireDateItems
    },
    currentYear() {
      return new Date().getFullYear()
    },
    selectedCategory() {
      return this.flattenMasterCategories.find(
        masterCategory => masterCategory.id === Number(this.inputValues.masterCategoryId)
      )
    },
    isShowWithholding() {
      if (!this.selectedCategory) {
        return false
      }

      return this.selectedCategory.isAvailableWithholding && this.isInvoiceAvailable
    }
  },
  methods: {
    detailComponentName(displayStyle) {
      return 'Contents' + displayStyle.charAt(0).toUpperCase() + displayStyle.slice(1)
    },
    cautionText(cautionList) {
      if (cautionList && Array.isArray(cautionList) && this.inputValues.masterCategoryId) {
        return cautionList
          .filter(item => item.master_category_ids.includes(this.inputValues.masterCategoryId))
          .map(item => item.text)
      }
      return []
    },
    setDetailDescription(itemName) {
      // 複数フォームの入力値に連動して出す説明文を作る
      this.detailDescription = ''

      const currentKey = findKey(this.requestItemsList, ['name', itemName])
      const currentItem = this.requestItemsList[currentKey] || null
      if (currentItem === null) {
        return
      }

      if (currentItem.optionJson.descriptionReferenceName) {
        // 現在入力しているのが説明文を表示するフォームの場合（例：記事単価）
        const unitPrice = this.calcurateUnitPrice(
          this.inputValues[itemName],
          this.inputValues[currentItem.optionJson.descriptionReferenceName]
        )

        if (isFinite(unitPrice)) {
          this.detailDescription =
            1 + currentItem.optionJson.description + unitPrice + currentItem.optionJson.unit
        }
      } else if (currentItem.optionJson.relatedDescriptionName) {
        // 現在入力しているのが説明文を作るために参照されるフォームの場合（例：1記事の文字数）
        const relatedKey = findKey(this.requestItemsList, [
          'name',
          currentItem.optionJson.relatedDescriptionName
        ])
        const relatedItem = this.requestItemsList[relatedKey] || null

        const unitPrice = this.calcurateUnitPrice(
          this.inputValues[currentItem.optionJson.relatedDescriptionName],
          this.inputValues[itemName]
        )

        if (isFinite(unitPrice)) {
          this.detailDescription =
            1 + relatedItem.optionJson.description + unitPrice + relatedItem.optionJson.unit
        }
      }
    },
    calcurateUnitPrice(dividend, divisor) {
      // 単価の計算（例： 記事単価 ÷ 1記事の文字数 = 文字単価）
      const unitPrice = dividend / divisor
      return Math.round(unitPrice * 10) / 10
    },
    initializeData() {
      // dataを初期化
      // 同じnameの入力値は維持する
      const oldInputValues = this.inputValues
      const oldDetailInputValidations = this.detailInputValidations

      this.inputValues = {}
      this.detailInputValidations = {}
      this.requiredInputNames = []
      this.requiredDetailInputNames = []

      FIXED_INPUT_NAMES.forEach(fixedInputName => {
        this.inputValues[fixedInputName] = oldInputValues[fixedInputName] || null
      })

      if (!this.isShowWithholding) {
        // 源泉徴収フラグは表示対象外の場合削除
        delete this.inputValues['withholdingTaxFlag']
      }

      FIXED_REQUIRED_INPUT_NAMES.forEach(fixedRequiredInputName => {
        this.requiredInputNames.push(fixedRequiredInputName)
      })

      this.requestItemsList.forEach(requestItem => {
        if (requestItem.requiredFlag) {
          this.requiredDetailInputNames.push(requestItem.name)
          this.detailInputValidations[requestItem.name] = false // invalid
        } else {
          this.detailInputValidations[requestItem.name] = true // valid
        }

        this.inputValues[requestItem.name] = oldInputValues[requestItem.name] || null

        if (this.inputValues[requestItem.name] !== null) {
          this.detailInputValidations[requestItem.name] =
            oldDetailInputValidations[requestItem.name]
        }
      })

      this.calculateRemainingCount()
    },
    changeCategory(masterCategoryId) {
      this.inputValues.masterCategoryId = masterCategoryId
      this.calculateRemainingCount()

      // 変更後のカテゴリ最低価格が選択中の価格より大きい場合、価格選択をリセット
      const selectedCategory = this.flattenMasterCategories.find(c => c.id === masterCategoryId)
      const selectedPriceItem = this.priceItems.find(pi => pi.value === this.selectedPrice)
      if (
        selectedPriceItem &&
        selectedCategory &&
        selectedPriceItem.maxPrice < selectedCategory.lowestPrice
      ) {
        this.selectedPrice = null
        this.changePrice()
      }

      this.isValidCategory = masterCategoryId ? true : false
      this.$emit('change-category', this.isValidCategory)
    },
    changeDetail(inputItem) {
      // 「依頼の内容」の入力値の反映
      this.inputValues[inputItem.name] = inputItem.value
      this.detailInputValidations[inputItem.name] = inputItem.isValid
      this.calculateRemainingCount()
      this.validateDetail()
      this.setDetailDescription(inputItem.name)
    },
    validateDetail() {
      // 「依頼の内容」のバリデーション
      const isValid = !Object.values(this.detailInputValidations).includes(false)
      this.$emit('change-detail', isValid)
    },
    changeDetailOther(inputItem) {
      // その他入力欄の入力値の反映
      this.inputValues[inputItem.name] = inputItem.value
      this.detailInputValidations[inputItem.name] = inputItem.isValid
      this.validateDetail()
    },
    toggleDetailOther(toggleItem) {
      // その他入力欄の表示オンオフに伴うdataの出し入れ
      if (toggleItem.isShow) {
        this.inputValues[toggleItem.name] = this.inputValues[toggleItem.name] || null
        this.detailInputValidations[toggleItem.name] =
          this.detailInputValidations[toggleItem.name] || true
      } else {
        delete this.inputValues[toggleItem.name]
        delete this.detailInputValidations[toggleItem.name]
      }
      this.validateDetail()
    },
    changePrice() {
      const selectedPriceItem = this.priceItems.find(pi => pi.value === this.selectedPrice)
      if (selectedPriceItem) {
        this.inputValues.priceMin = selectedPriceItem.minPrice
        this.inputValues.priceMax = selectedPriceItem.maxPrice
      } else {
        this.inputValues.priceMin = null
        this.inputValues.priceMax = null
      }
      this.calculateRemainingCount()
      this.$emit('change-price', !!selectedPriceItem)
    },
    changeExpireDate() {
      this.calculateRemainingCount()
      this.$emit('change-date', this.inputValues.expireDate !== null)
    },
    changeDeliveryDate() {
      this.setDeliveryDateList()

      if (!this.deliveryMonthList.includes(this.inputValues.deliveryDateMonth)) {
        // 選択肢に存在しない月を選択していた場合、未選択に戻す
        this.inputValues.deliveryDateMonth = null
      }

      if (!this.deliveryDayList.includes(this.inputValues.deliveryDateDay)) {
        // 選択肢に存在しない日を選択していた場合、未選択に戻す
        this.deliveryDateDay = null
        this.inputValues.deliveryDateDay = null
      }
    },
    changeDeliveryDateDay() {
      // createdで動的に作ったdataをv-modelで指定し、さらにその選択肢も選んだ月によって変えると、
      // 選択していた選択肢が消えたときの挙動が不安定だったため、一旦固定のdataを指定してchange時に代入するようにした
      this.inputValues.deliveryDateDay = this.deliveryDateDay
    },
    setDeliveryDateList() {
      // createdで動的に作ったdataをcomputedで使うと、その値が変化してもcomputedが再計算されないため、
      // dataで持った値を必要なときにmethodから更新するようにした
      this.setDeliveryMonthList()
      this.setDeliveryDayList()
    },
    setDeliveryMonthList() {
      if (this.inputValues.deliveryDateYear === this.currentYear) {
        const currentMonth = new Date().getMonth() + 1
        this.deliveryMonthList = range(currentMonth, 13)
        return
      }

      this.deliveryMonthList = range(1, 13) // 1 ~ 12
    },
    setDeliveryDayList() {
      const date = new Date()
      const currentMonth = date.getMonth() + 1
      let minDeliveryDay = 1
      if (
        this.inputValues.deliveryDateYear === this.currentYear &&
        this.inputValues.deliveryDateMonth === currentMonth
      ) {
        // 当日以前は選択できない
        minDeliveryDay = date.getDate() + 1
      }

      let maxDeliveryDay = 31
      if (this.inputValues.deliveryDateYear > 0 && this.inputValues.deliveryDateMonth > 0) {
        // 選択した月の日数
        maxDeliveryDay = new Date(
          this.inputValues.deliveryDateYear,
          this.inputValues.deliveryDateMonth,
          0
        ).getDate()
      }

      this.deliveryDayList = range(minDeliveryDay, maxDeliveryDay + 1)
    },
    calculateRemainingCount() {
      // 残りの入力が必要な必須項目数の計算
      let remainingCount = 0
      this.requiredInputNames.forEach(requiredInputName => {
        if (this.inputValues[requiredInputName] === null) {
          remainingCount++
        }
      })

      let remainingDetailCount = 0
      this.requiredDetailInputNames.forEach(requiredDetailInputName => {
        if (this.detailInputValidations[requiredDetailInputName] === false) {
          remainingCount++
          remainingDetailCount++
        }
      })

      this.remainingCount = remainingCount
      this.remainingDetailCount = remainingDetailCount
    }
  }
}
</script>
<style lang="scss" scoped>
.c-requestAddContents {
  h2 {
    font-weight: bold;
  }

  &_divider {
    margin: 60px 0 0;
    padding-top: 60px;
    height: 0;
    border-top: 1px solid $color-gray-200;
    background-color: transparent;
  }

  &_heading,
  &_title {
    display: flex;

    align-items: center;
  }

  &_label {
    display: inline-block;
    padding: 0 10px;
    border: 1px solid $color-gray-700;
    border-radius: 6px;
    background-color: $color-white;
    color: $color-gray-700;
    white-space: nowrap;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;

    &-required {
      border: 1px solid $color-red-500;
      color: $color-red-500;
    }
  }

  &_caution {
    color: $color-red-500;
    margin-bottom: 4px;
  }

  &_expireDateNotice {
    margin-top: 4px;
    font-size: 12px;
  }

  &_priceCaution {
    margin-top: 6px;
    font-size: 12px;
    line-height: 16px;
    &-beforeHoldingTax {
      margin-bottom: 20px;
    }
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-requestAddContents {
    &_heading {
      padding: 24px 12px 8px;
      border-top: 1px solid $color-gray-200;
      border-bottom: 1px solid $color-gray-200;
      background-color: $color-gray-50;
      font-size: 14px;

      justify-content: space-between;

      &-noBorder {
        border: 0;
      }
    }

    &_detailItem {
      padding: 24px 12px;

      &-noTitle {
        padding: 8px 12px 24px;
      }

      &-noTitleAndSubTitle {
        margin-top: -24px;
      }
    }

    &_title {
      margin-bottom: 8px;
      font-size: 14px;

      justify-content: space-between;
    }

    &_subTitle {
      margin-bottom: 4px;
      color: $color-gray-700;
      font-size: 12px;
    }

    &_caution {
      font-size: 12px;
    }

    &_price {
      padding: 24px 12px;

      /deep/ .select {
        width: 100%;
        height: 40px;

        select {
          padding-left: 12px;
          width: 100%;
          height: 40px;
          font-size: 14px;
        }
      }

      /deep/ .control-label {
        font-size: 14px;
      }
    }

    &_priceNotice {
      margin: 4px 0 0;
      font-size: 12px;
    }

    &_date {
      padding: 24px 12px;

      /deep/ .select {
        min-width: 100%;
        height: 40px;

        select {
          padding-left: 12px;
          min-width: 100%;
          height: 40px;
          font-size: 12px;
        }
      }

      /deep/ .control-label {
        font-size: 14px;
      }
    }

    &_deliveryDateTitle {
      margin-top: 20px;
    }

    &_deliveryDate {
      display: flex;
      font-size: 12px;

      align-items: center;

      span {
        margin: 0 8px 0 4px;
      }

      /deep/ .select {
        min-width: 76px;
        height: 40px;

        select {
          padding-left: 12px;
          min-width: 76px;
          height: 40px;
          font-size: 12px;
        }
      }
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-requestAddContents {
    max-width: 722px;

    h3,
    h4 {
      font-weight: bold;
    }

    &_heading {
      font-size: 24px;
    }

    &_label {
      margin-left: 8px;
    }

    &_detailItem {
      margin-top: 40px;

      & + & {
        margin-top: 60px;
      }

      & + &-noTitle {
        margin-top: 40px;
      }

      & + &-noTitleAndSubTitle {
        margin-top: 20px;
      }
    }

    &_title {
      margin-bottom: 12px;
      font-size: 16px;
    }

    &_subTitle {
      margin-bottom: 8px;
      font-size: 14px;
    }

    &_price {
      /deep/ .select {
        min-width: 428px;
        height: 48px;

        select {
          padding-left: 12px;
          min-width: 428px;
          height: 48px;
          font-size: 16px;
        }
      }

      /deep/ .control-label {
        font-size: 14px;
      }
    }

    &_priceTitle {
      margin-top: 32px;
    }

    &_priceSubTitle {
      margin-top: 20px;
    }

    &_priceNotice {
      margin: 4px 0 0;
      font-size: 12px;
    }

    &_date {
      /deep/ .select {
        min-width: 428px;
        height: 48px;

        select {
          padding-left: 12px;
          min-width: 428px;
          height: 48px;
          font-size: 16px;
        }
      }

      /deep/ .control-label {
        font-size: 14px;
      }
    }

    &_expireDateTitle,
    &_deliveryDateTitle {
      margin-top: 32px;
    }

    &_deliveryDate {
      display: flex;
      font-size: 16px;

      align-items: center;

      span {
        margin: 0 16px 0 8px;
      }

      /deep/ .select {
        min-width: 124px;
        height: 48px;

        select {
          padding-left: 12px;
          min-width: 124px;
          height: 48px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>
